import React, { FC, useEffect } from 'react'
import { Flex, Text, Heading, Box } from '@moonpig/launchpad-components'
import { useExperiment } from '@moonpig/web-core-experiments'
import { useTrackGAEventOnce } from '@moonpig/web-core-analytics'
import { useInView } from 'react-intersection-observer'
import { ProductModule } from '../types'
import { ProductModuleSection } from '../ProductModuleSection'
import { useProductContext } from '../../../contexts/product'
import { useSellingPoints } from './useSellingPoints'
import { useFindLocaleText } from '../../../text-localisation'
import { hasProductVideo } from '../../../utils/getProductVideoId'
import { USPModuleImpressionGAEvent } from '../analytics'

export const USPModule: FC<ProductModule> = props => {
  const sellingPoints = useSellingPoints()
  const localiseText = useFindLocaleText()
  const { trackGAEventOnce } = useTrackGAEventOnce()
  const [
    {
      product: { id },
    },
  ] = useProductContext()
  const [uspModuleRef, inView] = useInView({
    threshold: 0.8,
    triggerOnce: true,
  })

  useEffect(() => {
    if (inView) {
      trackGAEventOnce(USPModuleImpressionGAEvent(id))
    }
  }, [trackGAEventOnce, id, inView])

  const shouldShowUSPModule =
    useExperiment('attach-product-video') === 'enabled' && hasProductVideo(id)

  return shouldShowUSPModule ? (
    <Box data-testid="usp-module" ref={uspModuleRef}>
      <ProductModuleSection {...props}>
        <Heading
          level="h4"
          typography={{
            xs: 'typeMobileDisplay03',
            md: 'typeDesktopDisplay05',
          }}
          paddingTop={{ xs: 7, md: 0 }}
          marginTop={{ xs: 8, md: 0 }}
          borderTop={{ xs: 1, md: 0 }}
          borderColor={{ xs: 'colorBorder03' }}
        >
          {localiseText('usp.title')}
        </Heading>
        {sellingPoints.map(point => (
          <Flex key={point.title} mt={4} alignItems={'center'}>
            <Box
              width="40px"
              height="40px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              {point.icon}
            </Box>
            <Box display="flex" flexDirection="column" marginLeft={6}>
              <Text
                typography={{
                  xs: 'typeMobileDisplay03',
                  md: 'typeDesktopDisplay05',
                }}
                color="colorTextLabel"
                fontWeight={400}
              >
                {point.title}
              </Text>
              <Text
                typography={{ xs: 'typeBodyText', md: 'typeBodyLead' }}
                fontWeight={400}
              >
                {point.description}
              </Text>
            </Box>
          </Flex>
        ))}
      </ProductModuleSection>{' '}
    </Box>
  ) : null
}
